export default "__VITE_ASSET__uzuI2JKl__"